import React from 'react';
import ReactPlayer from 'react-player';

import { Wrapper } from './style';

interface PropsType {
	url: string;
}

function ChunkVideo({ url }: PropsType) {
	return (
		<Wrapper>
			<ReactPlayer
				url={url}
				controls
				width="100%"
				height="100%"
				config={{
					file: {
						attributes: {
							controlsList: 'nodownload',
						},
					},
				}}
			/>
		</Wrapper>
	);
}

export default ChunkVideo;
